type ComputeKeyframePositionsArgsT = {
  startFrame: number;
  endFrame: number;
  step: number;
};

/**
 * Frame indices where the keyframe stepper drops keyframes: `startFrame`, then
 * every `step` frames up to (and not beyond) `endFrame`. Always includes
 * `startFrame` (the object's initial box). Returns `[]` only when
 * `startFrame > endFrame`.
 */
export const computeKeyframePositions = ({
  startFrame,
  endFrame,
  step
}: ComputeKeyframePositionsArgsT): number[] => {
  if (startFrame > endFrame) {
    return [];
  }
  if (step <= 0) {
    return [startFrame];
  }
  const positions: number[] = [];
  for (let frame = startFrame; frame <= endFrame; frame += step) {
    positions.push(frame);
  }
  return positions;
};